import { render, staticRenderFns } from "./pagenotfound.vue?vue&type=template&id=05bd4bd6&"
import script from "./pagenotfound.vue?vue&type=script&lang=js&"
export * from "./pagenotfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports